export default "__VITE_PUBLIC_ASSET__10ed0aee__"